import '../../styles/PasswordStrengthIndicator.scss';

import React from 'react';

import PropTypes from 'prop-types';

const PasswordStrengthIndicator = ({ password }) => {
  const getStrength = () => {
    if (
      password.length > 8 &&
      /[A-Z]/.test(password) &&
      /[0-9]/.test(password)
    ) {
      return "Strong";
    } else if (password.length > 5) {
      return "Medium";
    } else {
      return "Weak";
    }
  };

  const strength = getStrength();

  return (
    <div className={`password-strength ${strength.toLowerCase()}`}>
      <span>{strength}</span>
      <div className={`indicator ${strength.toLowerCase()}`}></div>
    </div>
  );
};

PasswordStrengthIndicator.propTypes = {
  password: PropTypes.string.isRequired,
};

export default PasswordStrengthIndicator;
